import {
  DEFAULT_GAP_REVIEW_CONFIDENCE,
  GapDraftReviewConfidence,
  type GapDraftView,
} from '@momentum/types';

/**
 * How sure the reviewer is of the verdict they are filing — on a keep as much
 * as on a drop.
 *
 * The value is required on every decision, so the reader asks for it between
 * the verdict keystroke and the write rather than carrying a preselected level
 * the reviewer never looked at. What follows is only what the picker needs to
 * draw itself.
 */

/** Low → high, the order the picker offers them in. */
export const REVIEW_CONFIDENCE_LEVELS: GapDraftReviewConfidence[] = [
  GapDraftReviewConfidence.LOW,
  GapDraftReviewConfidence.MEDIUM,
  GapDraftReviewConfidence.HIGH,
];

/**
 * The level the picker opens on.
 *
 * A decided draft opens on its own recorded level: reopening the picker is how
 * a reviewer CHANGES a verdict's confidence, so it has to start from the one on
 * record rather than from the default. Everything else — undecided, or decided
 * before the field existed — opens on {@link DEFAULT_GAP_REVIEW_CONFIDENCE}.
 */
export function reviewConfidenceOf(
  draft: GapDraftView | undefined
): GapDraftReviewConfidence {
  return draft?.review.reviewConfidence ?? DEFAULT_GAP_REVIEW_CONFIDENCE;
}
